import { makeStyles, createMuiTheme } from "@material-ui/core";

// update log
// FB 4371 DK     03/29/2021    Added page to handle CSS globally
// FB 4409 DK     04/28/2021    Removed hover functionality to the buttonActive class
// FB 4574 DK     07/15/2021    Added new class for dropdowm icons
// FB 4867 DK     12/27/2021    Added screens for Support files and Health forms upload

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#18a2b8",
    },
  },
});

const useStyles = makeStyles({
  appBar: {
    backgroundColor: "#18a2b8",
    display: "flex",
    flexDirection: "row",
  },
  appTitle: {
    flexGrow: 1,
    color: "white",
  },
  logo: {
    maxWidth: 400,
    maxHeight: 150,
    [theme.breakpoints.down("xs")]: {
      maxWidth: 250,
      maxHeight: 70,
    }
  },

  // FB 4409 DK - Removed hover functionality, Changed the backgroundcolor and font color to the buttonActive class
  buttonActive: {
    backgroundColor: "#B9E3E9",
    color: "black",
    textTransform: "capitalize",
    borderRadius: "15px",
    pointerEvents: "none",
    // "&:hover": {
    //   backgroundColor: "#46B4C6",
    // },
    width: "-webkit-fill-available",
  },
  buttonInactive: {
    backgroundColor: "white",
    color: "#18a2b8",
    textTransform: "capitalize",
    borderRadius: "15px",
    width: "-webkit-fill-available",
  },
  navigationButton: {
    backgroundColor: "#18a2b8",
    color: "white",
    textTransform: "capitalize",
    borderRadius: "15px",
    "&:hover": {
      backgroundColor: "#46B4C6",
    },
  },
  disabledButton: {
    backgroundColor: "lightgray",
    textTransform: "capitalize",
    color: "grey",
    borderRadius: "15px",
  },
  flexend_Grid: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexBasis: "unset",
  },
  //FB-4867 - DK - Start
  flexstart_Grid: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexBasis: "unset",
  },
  flexcenter_Grid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexBasis: "unset",
  },
  //FB-4867 - DK - End
  provider_Card: {
    maxWidth: 450,
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("md")]: {
      maxWidth: 300,
      display: "flex",
      flexDirection: "column",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: 250,
      display: "flex",
      flexDirection: "column",
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: "80%",
      display: "flex",
      flexDirection: "column",
    },
  },
  card_Avatar: {
    "&.MuiAvatar-root": {
      height: 170,
      width: 170,
    },
  },
  slotspage_Avatar: {
    "&.MuiAvatar-root": {
      height: 120,
      width: 120,
    },
  },
  slotspage_Card: {
    maxWidth: 450,
    display: "flex",
    flexDirection: "row",
    // [theme.breakpoints.down("xs")]: {
    //   maxWidth: "80%",
    //   display: "flex",
    //   flexDirection: "column",
    // },
  },
  slotslocation_Card: {
    //maxWidth: 450,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      flexDirection: "row",
    },
  },
  slotslocation_Avatar: {
    "&.MuiAvatar-root": {
      height: 120,
      width: 120,
      [theme.breakpoints.down("xs")]: {
        height: 90,
        width: 90,
      },
    },
  },
  location_Card: {
    maxWidth: 400,
    display: "flex",
    flexDirection: "row",
    minWidth: "70%",
    [theme.breakpoints.down("md")]: {
      maxWidth: 300,
      display: "flex",
      flexDirection: "column",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: 250,
      display: "flex",
      flexDirection: "column",
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
      display: "flex",
      flexDirection: "column",
    },
  },
  location_Cardmedia: {
    height: 170,
    width: 170,
  },
  bydateProviderCard: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  byDateScrollbar: {
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "10px",
      backgroundColor: "lightgray",
    },

    "&::-webkit-scrollbar-thumb:horizontal": {
      backgroundColor: "rgba(0,0,0,.5)",
      //outline: '1px solid slategrey'
    },
  },
  dropdown: {
    maxHeight: 150,
    "&:hover": {
      color: "white",
      backgroundColor: "#18a2b8",
    },
  },
  dropdown_nomargin: {
    "& .MuiFormControl-marginNormal": {
      margin: 0,
    },
  },
  datepickerroot: {
    "& .MuiIconButton-root": {
      color: "#18a2b8",
    },
    // FB 4574 DK - Added to increase the size of icon
    "& .MuiSvgIcon-root": {
      fontSize: "2rem"
    }
  },
  fabButton: {
    margin: theme.spacing(2),
    "&.MuiFab-root": {
      backgroundColor: "#2FABBF",
      color: "white",
    },
    "&:hover": {
      backgroundColor: "#46B4C6",
    },
  },
  navigationArrows: {
    color: "#18a2b8",
  },
  //FB 4867 DK - Made few changes to OTP styles - Start
  otp: {
    width: "2rem !important",
    height: "2rem",
    margin: "0 0.5rem",
    fontSize: "1rem",
    border: "2px solid gray",
    "&:focus": {
      border: "2px solid #18a2b8",
      outlineColor: "transparent",
    },
  },
  otpError: {
    border: "2px solid red",
  },
  //FB 4867 DK - Made few changes to OTP styles - End
  radioGroup: {
    "&.MuiFormGroup-root": {
      flexDirection: "row",
    },
  },
  disabledTextfield: {
    "&.Mui-disabled": {
      color: "black",
    },
  },
  // FB 4574 DK - Added new class to increase the size of icon
  autocompleteIcon: {
    "& .MuiSvgIcon-root": {
      fontSize: "2rem"
    }
  }
});

export default useStyles;
